// 任务管理
export default {
    unpublished: '未发布',
    published: '已发布',
    inExecution: '执行中',
    completed: '已完成',
    deleted: '已删除',
    taskTotal: '任务总数',
    newTask: '新建任务',
    approvalStatus: '审批状态',
    all: '全部',
    pending: '待审批',
    timeoutNotApproved: '超时未审批',
    didNotPass: '未通过',
    approved: '已审批',
    generateReport: '生成报告',
    approver: '审批人',
    reason: '原因',
    taskNature: '任务性质',
    aging: '时效',
    efficient: '有效',
    invalid: '无效',
    onTime: '按时',
    timeOut: '超时',
    taskStatus: '任务状态',
    model: '机型',
    mount: '挂载',
    submit: '提交',
    release: '发布',
    revoke: '撤销',
    check: '查看',
    achievementDisplay: '成果展示',
    recover: '恢复',
    postTask: '发布任务',
    missionReport: '任务报告',
    tip_submit: '是否确定提交？',
    drawingScale: '成图比例',
    area: '面积',
    mu: '亩',
    perimeter: '周长',
    have: '有',
    without: '无',
    workLocation: '作业地点',
    tip_selectDev: '请选择设备类型',
    tip_selectMount: '请选择挂载类型',
    tip_enterDeadline: '请输入截止时间',
    other: '其他',
    tip_leastOne: '请至少规划一个点',
    tip_leastThree: '请至少规划三个点',
    siteName: '站点名',
    selectNumber: '选中点数量',
    tip_enterSiteName: '请输入站点名',
    public: '公开',
    personal: '个人',
    personalAndShared: '个人及共享',
    customize: '自定义',
    userName: '用户名',
    tip_userName: '请输入用户名',
    tip_phoneNumber: '请输入手机号码',
    phoneNumber: '手机号',
    department: '所属部门',
    licenseType: '执照类型',
    systemNotification: '系统通知',
    viewTasks: '查看任务',
    executor: '执行人',
    uavNumber: '飞机编号',
    flightTime: '飞行时长',
    founder: '创建人',
    finisher: '完成人',
    role: '角色',
    exportReport: '导出报告',
    cumulativeTime: '累计用时',
    taskName: '任务名称',
    startingPoint: '起点',
    alreadyHave: '已有',
    new: '新建',
    mapPickup: '地图拾取',
    endPoint: '终点',
    automaticApproval: '自动审批',
}